import Svg, { Path } from "react-native-svg";
import type { SvgProps } from "react-native-svg";
import { memo } from "react";
const SvgTabIconInfo = (props: SvgProps) => <Svg xmlns="http://www.w3.org/2000/svg" width={11} height={12} fill="none" viewBox="0 0 11 12" {...props}><Path fill="currentColor" d="M5.75.75a5.25 5.25 0 1 1 0 10.5 5.25 5.25 0 0 1 0-10.5Zm.817 3.5V2.617H4.933V4.25h1.634Zm0 5.367V5.183H4.933v4.434h1.634Z" /></Svg>;
const Memo = memo(SvgTabIconInfo);
export default Memo;